import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './AlertBanner.module.scss';

const AlertBanner = ({
  type,
  title = null,
  message,
  onClickCloseButton = null,
}) => (
  <div className={classnames(styles[type], styles['alert-banner'])}>
    <>
      <div className={styles['icon-wrapper']}>
        <div className={styles['alert-icon']} />
      </div>
      <div className={styles['alert-content']}>
        {title && (
          <div className={styles['alert-title']}>{title}</div>
        )}
        <div className={styles['alert-message']}>{message}</div>
      </div>
    </>
    {onClickCloseButton && (
      <div
        className={styles['btn-close-alert']}
        role="button"
        tabIndex="0"
        onClick={onClickCloseButton}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClickCloseButton();
          }
        }}
        data-testid="btn-close-alert"
        aria-label={title}
      />
    )}
  </div>
);

AlertBanner.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClickCloseButton: PropTypes.func,
  type: PropTypes.oneOf(['nofication', 'success', 'warning', 'error', 'info']).isRequired,
};

export default AlertBanner;
